export default {
    // 中
    zhCN: {
        fill_in_at_least_one_query_condition: '至少填写一个查询条件',
        query_time: '查询时间',
        reporting_organization_name: '上报组织名称',
        full_query: '全量查询',
        organization_code: '组织CODE',
        organization_name: '组织名称',
        country: '国家',
        number_of_cases: '案例总数',
        wait_for_superiors_to_reply_cases: '等待上级答复案例数量',
        percentage_wait_for_superiors_to_reply_cases: '等待上级答复案例百分比',
        superior_replied_casess: '上级已答复案例数量',
        percentage_superior_replied_casess: '上级已答复案例数量百分比',
        closed_cases: '已结案案例数量',
        percentage_closed_cases: '已结案数量百分比',
    },
    // 英
    enUS: {
        fill_in_at_least_one_query_condition: 'Fill in at least one query condition',
        query_time: 'Query time',
        reporting_organization_name: 'Reporting organization name',
        full_query: 'Full query',
        organization_code: 'Organization code',
        organization_name: 'Organization name',
        country: 'Country',
        number_of_cases: 'Number of cases',
        wait_for_superiors_to_reply_cases: 'Wait for superiors to reply cases',
        percentage_wait_for_superiors_to_reply_cases: 'Wait for superiors to reply cases (%)',
        superior_replied_casess: 'Superior replied cases',
        percentage_superior_replied_casess: 'Superior replied cases (%)',
        closed_cases: 'Closed cases',
        percentage_closed_cases: 'Closed cases (%)',
    },
    // 德
    deDE: {
        fill_in_at_least_one_query_condition: 'Füllen Sie mindestens eine Abfragebedingung aus',
        query_time: 'Abfragezeit',
        reporting_organization_name: 'Name der meldenden Organisation',
        full_query: 'Vollständige Abfrage',
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        country: 'Land',
        number_of_cases: 'Gesamtzahl der Fälle',
        wait_for_superiors_to_reply_cases: 'Fälle, auf Antwort der Vorgesetzten warten',
        percentage_wait_for_superiors_to_reply_cases:
            'Fälle, auf Antwort der Vorgesetzten warten (%)',
        superior_replied_casess: 'Vorgesetzte beantwortete Fälle',
        percentage_superior_replied_casess: 'Vorgesetzte beantwortete Fälle (%)',
        closed_cases: 'Geschlossene Fälle',
        percentage_closed_cases: 'Geschlossene Fälle (%)',
    },
    // 法
    frFR: {
        fill_in_at_least_one_query_condition: 'Remplissez au moins une condition de demande',
        query_time: 'Temps de requête',
        reporting_organization_name: 'Nom de l\'organisation de rapport',
        full_query: 'Requête complète',
        organization_code: 'Code organisation',
        organization_name: 'Nom organisation',
        country: 'Pays',
        number_of_cases: 'Nombre de cas',
        wait_for_superiors_to_reply_cases: 'Cas en attente de retour',
        percentage_wait_for_superiors_to_reply_cases: 'Cas en attente de retour (%)',
        superior_replied_casess: 'Cas répondus',
        percentage_superior_replied_casess: 'Cas répondus (%)',
        closed_cases: 'Cas clôturés',
        percentage_closed_cases: 'Cas clôturés (%)',
    },
    // 意大利
    itIT: {
        fill_in_at_least_one_query_condition: 'Compilare almeno una condizione di query',
        query_time: 'Tempo di Query',
        reporting_organization_name: 'Nome Organizzazione Segnalante',
        full_query: 'Query Completa',
        organization_code: 'Codice Organizzazione',
        organization_name: 'Nome Organizzazione',
        country: 'Paese',
        number_of_cases: 'Numero totale di casi',
        wait_for_superiors_to_reply_cases:
            'Numero di Casi in Attesa di Risposta da Parte dei Superiori',
        percentage_wait_for_superiors_to_reply_cases:
            'Percentuale di Casi in Attesa di Risposta da Parte dei Superiori',
        superior_replied_casess: 'Numero di Casi a cui i Superiori hanno Risposto',
        percentage_superior_replied_casess: 'Percentuale di Casi a cui i Superiori hanno Risposto',
        closed_cases: 'Numero di Casi Chiusi',
        percentage_closed_cases: 'Percentuale di Casi Chiusi',
    },
    // 荷兰
    nlNL: {
        fill_in_at_least_one_query_condition: 'Vul ten minste één query voorwaarde in',
        query_time: 'Query time',
        reporting_organization_name: 'Rapporterende organisatienaam',
        full_query: 'Volledige query',
        organization_code: 'Organisatie code',
        organization_name: 'Organisatie naam',
        country: 'Land',
        number_of_cases: 'Totaal aantal gevallen',
        wait_for_superiors_to_reply_cases: 'Wachten op antwoord van superieuren',
        percentage_wait_for_superiors_to_reply_cases: 'Wachten op antwoord van superieuren(%)',
        superior_replied_casess: 'Superieure beantwoorde gevallen',
        percentage_superior_replied_casess: 'Superieure beantwoorde gevallen(%)',
        closed_cases: 'Gesloten gevallen',
        percentage_closed_cases: 'Gesloten gevallen(%)',
    },
    // 越南
    viVN: {
        fill_in_at_least_one_query_condition: 'Ít nhất điền một điều kiện tìm kiếm',
        query_time: 'Thời gian truy vấn',
        reporting_organization_name: 'Tên tổ chức báo cáo',
        full_query: 'Tra cứu toàn bộ',
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        country: 'Quốc gia',
        number_of_cases: 'Số lượng trường hợp',
        wait_for_superiors_to_reply_cases: 'Các trường hợp chờ cấp trên trả lời',
        percentage_wait_for_superiors_to_reply_cases:
            'Tỉ lệ các trường hợp chờ cấp trên trả lời (%)',
        superior_replied_casess: 'Các trường hợp cấp trên đã trả lời',
        percentage_superior_replied_casess: 'Tỉ lệ các trường hợp cấp trên đã trả lời (%)',
        closed_cases: 'Các trường hợp đã đóng',
        percentage_closed_cases: 'Tỉ lệ các trường hợp đã đóng (%)',
    },
    // 西班牙
    esES: {
        fill_in_at_least_one_query_condition: 'Al menos complete un criterio de búsqueda',
        query_time: 'Consulta de tiempo',
        reporting_organization_name: 'Nombre de la organización informante',
        full_query: 'Consulta completa',
        organization_code: 'Código de la organización',
        organization_name: 'Nombre de la organización',
        country: 'País',
        number_of_cases: 'Número total de casos',
        wait_for_superiors_to_reply_cases:
            'Número de casos pendientes de respuesta de los superiores',
        percentage_wait_for_superiors_to_reply_cases:
            'Porcentaje de casos pendientes de respuesta de los superiores',
        superior_replied_casess: 'Número de casos respondidos por los superiores',
        percentage_superior_replied_casess: 'Porcentaje de casos respondidos por los superiores',
        closed_cases: 'Número de casos cerrados',
        percentage_closed_cases: 'Porcentaje de casos cerrados',
    },
    // 葡萄牙
    ptBR: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        query_time: 'Tempo de consulta',
        reporting_organization_name: 'Nome da organização de reportagem',
        full_query: 'Consulta completa',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        wait_for_superiors_to_reply_cases: 'Número de casos aguardando resposta dos superiores',
        percentage_wait_for_superiors_to_reply_cases:
            'Porcentagem de casos aguardando resposta dos superiores',
        superior_replied_casess: 'Número de casos respondidos pelos superiores',
        percentage_superior_replied_casess: 'Porcentagem de casos respondidos pelos superiores',
        closed_cases: 'Número de casos encerrados',
        percentage_closed_cases: 'Porcentagem de casos encerrados',
    },
    // 波兰
    plPL: {
        fill_in_at_least_one_query_condition: 'Wypełnij co najmniej jeden warunek zapytania',
        query_time: 'Data zapytania',
        reporting_organization_name: 'Nazwa organizacji raportującej',
        full_query: 'Pełne zapytanie',
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        country: 'Kraj',
        number_of_cases: 'Łączna liczba spraw',
        wait_for_superiors_to_reply_cases: 'Liczba spraw oczekujących na odpowiedź przełożonego',
        percentage_wait_for_superiors_to_reply_cases:
            'Liczba spraw oczekujących na odpowiedź przełożonego (%)',
        superior_replied_casess: 'Odpowiedzi udzielone przez przełożonego',
        percentage_superior_replied_casess: 'Odpowiedzi udzielone przez przełożonego (%)',
        closed_cases: 'Sprawy zamknięte',
        percentage_closed_cases: 'Sprawy zamknięte (%)',
    },
    // 土耳其
    trTR: {
        fill_in_at_least_one_query_condition: 'En azından bir soru durumunu doldur',
        query_time: 'Sorgulama zamanı',
        reporting_organization_name: 'Bildirim organizasyonu adı',
        full_query: 'Tam sorgulama',
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        country: 'Ülke',
        number_of_cases: 'Dosya sayısı',
        wait_for_superiors_to_reply_cases: 'Uzman kişinin dosyayı cevaplaması bekleniyor',
        percentage_wait_for_superiors_to_reply_cases:
            'Uzman kişinin dosyayı cevaplaması bekleniyor (%)',
        superior_replied_casess: 'Uzmanın cevapladığı dosyalar',
        percentage_superior_replied_casess: 'Uzmanın cevapladığı dosyalar  (%)',
        closed_cases: 'Kapatılmış dosyalar',
        percentage_closed_cases: 'Kapatılmış davalar (%)',
    },
    // 捷克语
    csCZ: {
        fill_in_at_least_one_query_condition: 'Vyplňte alespoň jednu podmínku dotazu',
        query_time: 'Čas dotazu',
        reporting_organization_name: 'Název ohlašující společnosti',
        full_query: 'Úplný dotaz',
        organization_code: 'Kód společnosti',
        organization_name: 'Název společnosti',
        country: 'Země',
        number_of_cases: 'Počet případů',
        wait_for_superiors_to_reply_cases: 'Wait for superiors to reply cases',
        percentage_wait_for_superiors_to_reply_cases: 'Wait for superiors to reply cases (%)',
        superior_replied_cases: 'Nadřízený odpověděl případy',
        percentage_superior_replied_cases: 'Nadřízený odpověděl případy (%)',
        closed_cases: 'Uzavřené případy',
        percentage_closed_cases: 'Uzavřené případy (%)',
    },
    // 匈牙利语
    huHU: {
        fill_in_at_least_one_query_condition: 'Töltsön ki legalább egy lekérdezési feltételt',
        query_time: 'Lekérdezési idő',
        reporting_organization_name: 'Jelentő szervezet neve',
        full_query: 'Teljes lekérdezés',
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        country: 'Ország',
        number_of_cases: 'Esetek száma',
        wait_for_superiors_to_reply_cases: 'Felettesek reakciójára váró esetek',
        percentage_wait_for_superiors_to_reply_cases: 'Felettesek reakciójára váró esetek (%)',
        superior_replied_casess: 'Felettes által megválaszolt esetek',
        percentage_superior_replied_casess: 'Felettes által megválaszolt esetek (%)',
        closed_cases: 'Lezárt esetek',
        percentage_closed_cases: 'Lezárt esetek (%)',
    },
    // 俄罗斯语
    ruRU: {
        fill_in_at_least_one_query_condition: 'Заполните хотя бы одно условие запроса',
        query_time: 'Время запроса',
        reporting_organization_name: 'Название отчетной организации',
        full_query: 'Полный запрос',
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        country: 'Страна',
        number_of_cases: 'Общее количество случаев',
        wait_for_superiors_to_reply_cases: 'Количество случаев, ожидающих ответа от руководства',
        percentage_wait_for_superiors_to_reply_cases:
            'Процент случаев, ожидающих ответа от руководства',
        superior_replied_casess: 'Количество случаев, на которые ответил руководитель',
        percentage_superior_replied_casess: 'Процент случаев, на которые ответил руководитель',
        closed_cases: 'Количество закрытых случаев',
        percentage_closed_cases: 'Процент закрытых случаев',
    },
    // 沙特阿拉伯
    arSA: {
        fill_in_at_least_one_query_condition: 'يرجى إدخال شرط بحث واحد على الأقل',
        query_time: 'وقت الاستعلام',
        reporting_organization_name: 'اسم المنظمة المبلغة',
        full_query: 'استعلام كامل',
        organization_code: 'رمز المنظمة',
        organization_name: 'اسم المنظمة',
        country: 'الدولة',
        number_of_cases: 'إجمالي عدد الحالات',
        wait_for_superiors_to_reply_cases: 'عدد الحالات التي تنتظر ردّ المدير',
        percentage_wait_for_superiors_to_reply_cases: 'نسبة الحالات التي تنتظر ردّ المدير',
        superior_replied_casess: 'عدد الحالات التي ردّ عليها المدير',
        percentage_superior_replied_casess: 'نسبة الحالات التي ردّ عليها المدير',
        closed_cases: 'عدد الحالات المغلقة',
        percentage_closed_cases: 'نسبة الحالات المغلقة',
    },
    // 保加利亚
    bgBG: {
        fill_in_at_least_one_query_condition: 'Моля, попълнете поне едно условие за търсене',
        query_time: 'Време на заявката',
        reporting_organization_name: 'Име на докладващата организация',
        full_query: 'Пълен заявкa',
        organization_code: 'Код на организацията',
        organization_name: 'Име на организацията',
        country: 'Държава',
        number_of_cases: 'Общ брой случаи',
        wait_for_superiors_to_reply_cases: 'Брой случаи, изчакващи отговор от ръководството',
        percentage_wait_for_superiors_to_reply_cases:
            'Процент случаи, изчакващи отговор от ръководството',
        superior_replied_casess: 'Брой случаи с отговор от ръководството',
        percentage_superior_replied_casess: 'Процент случаи с отговор от ръководството',
        closed_cases: 'Брой приключени случая',
        percentage_closed_cases: 'Процент приключени случаи',
    },
    // 丹麦语
    daDK: {
        fill_in_at_least_one_query_condition: 'Angiv mindst ét søgekriterie',
        query_time: 'Forespørgselstidspunkt',
        reporting_organization_name: 'Rapporterende organisationsnavn',
        full_query: 'Fuld forespørgsel',
        organization_code: 'Organisationskode',
        organization_name: 'Organisationsnavn',
        country: 'Land',
        number_of_cases: 'Samlet antal sager',
        wait_for_superiors_to_reply_cases: 'Antal sager, der afventer svar fra overordnede',
        percentage_wait_for_superiors_to_reply_cases:
            'Procentdel af sager, der afventer svar fra overordnede',
        superior_replied_casess: 'Antal sager besvaret af overordnede',
        percentage_superior_replied_casess: 'Procentdel af sager besvaret af overordnede',
        closed_cases: 'Antal lukkede sager',
        percentage_closed_cases: 'Procentdel af lukkede sager',
    },
    // 芬兰语
    fiFI: {
        fill_in_at_least_one_query_condition: 'Anna vähintään yksi hakuehto',
        query_time: 'Hakuaika',
        reporting_organization_name: 'Ilmoittavan organisaation nimi',
        full_query: 'Koko tietojoukko',
        organization_code: 'Organisaatiokoodi',
        organization_name: 'Organisaation nimi',
        country: 'Maa',
        number_of_cases: 'Tapauksien kokonaismäärä',
        wait_for_superiors_to_reply_cases: 'Ylemmän johdon vastaamattomien tapausten määrä',
        percentage_wait_for_superiors_to_reply_cases:
            'Ylemmän johdon vastaamattomien tapausten prosenttiosuus',
        superior_replied_casess: 'Ylemmän johdon vastattujen tapausten määrä',
        percentage_superior_replied_casess: 'Ylemmän johdon vastattujen tapausten prosenttiosuus',
        closed_cases: 'Suljettujen tapausten määrä',
        percentage_closed_cases: 'Suljettujen tapausten prosenttiosuus',
    },
    // 繁体中文台湾
    zhTW: {
        fill_in_at_least_one_query_condition: '至少填寫一個查詢條件',
        query_time: '查詢時間',
        reporting_organization_name: '上報組織名稱',
        full_query: '全量查詢',
        organization_code: '組織CODE',
        organization_name: '組織名稱',
        country: '國家',
        number_of_cases: '案例總數',
        wait_for_superiors_to_reply_cases: '等待上級答覆案例數量',
        percentage_wait_for_superiors_to_reply_cases: '等待上級答覆案例百分比',
        superior_replied_casess: '上級已答覆案例數量',
        percentage_superior_replied_casess: '上級已答覆案例數量百分比',
        closed_cases: '已結案案例數量',
        percentage_closed_cases: '已結案數量百分比',
    },
    // 克罗地亚
    hrHR: {
        fill_in_at_least_one_query_condition: 'Unesite barem jedan uvjet pretraživanja',
        query_time: 'Vrijeme upita',
        reporting_organization_name: 'Naziv prijavljujuće organizacije',
        full_query: 'Potpuno upit',
        organization_code: 'Kôd organizacije',
        organization_name: 'Naziv organizacije',
        country: 'Država',
        number_of_cases: 'Ukupan broj slučajeva',
        wait_for_superiors_to_reply_cases: 'Broj slučajeva koji čekaju odgovor nadređenih',
        percentage_wait_for_superiors_to_reply_cases:
            'Postotak slučajeva koji čekaju odgovor nadređenih',
        superior_replied_casess: 'Broj slučajeva na koje su nadređeni odgovorili',
        percentage_superior_replied_casess: 'Postotak slučajeva na koje su nadređeni odgovorili',
        closed_cases: 'Broj zatvorenih slučajeva',
        percentage_closed_cases: 'Postotak zatvorenih slučajeva',
    },
    // 拉脱维亚
    lvLV: {
        fill_in_at_least_one_query_condition:
            'Lūdzu, aizpildiet vismaz vienu meklēšanas nosacījumu',
        query_time: 'Vaicājuma laiks',
        reporting_organization_name: 'Ziņojošās organizācijas nosaukums',
        full_query: 'Pilns vaicājums',
        organization_code: 'Organizācijas kods',
        organization_name: 'Organizācijas nosaukums',
        country: 'Valsts',
        number_of_cases: 'Gadījumu kopējais skaits',
        wait_for_superiors_to_reply_cases: 'Gadījumu skaits, kas gaida augstāka līmeņa atbildi',
        percentage_wait_for_superiors_to_reply_cases:
            'Gadījumu procents, kas gaida augstāka līmeņa atbildi',
        superior_replied_casess: 'Augstāka līmeņa atbildēto gadījumu skaits',
        percentage_superior_replied_casess: 'Augstāka līmeņa atbildēto gadījumu procents',
        closed_cases: 'Slēgto gadījumu skaits',
        percentage_closed_cases: 'Slēgto gadījumu procents',
    },
    // 立陶宛
    ltLT: {
        fill_in_at_least_one_query_condition: 'Įveskite bent vieną paieškos sąlygą',
        query_time: 'Užklausos laikas',
        reporting_organization_name: 'Pranešančios organizacijos pavadinimas',
        full_query: 'Visų duomenų užklausa',
        organization_code: 'Organizacijos kodas',
        organization_name: 'Organizacijos pavadinimas',
        country: 'Šalis',
        number_of_cases: 'Atvejų skaičius iš viso',
        wait_for_superiors_to_reply_cases: 'Laukiamų vyresnio lygio atsakymų atvejų skaičius',
        percentage_wait_for_superiors_to_reply_cases:
            'Laukiamų vyresnio lygio atsakymų atvejų procentas',
        superior_replied_casess: 'Vyresnio lygio atsakytų atvejų skaičius',
        percentage_superior_replied_casess: 'Vyresnio lygio atsakytų atvejų procentas',
        closed_cases: 'Uždarytų atvejų skaičius',
        percentage_closed_cases: 'Uždarytų atvejų procentas',
    },
    // 罗马尼亚
    roRO: {
        fill_in_at_least_one_query_condition: 'Completați cel puțin o condiție de căutare',
        query_time: 'Timpul interogării',
        reporting_organization_name: 'Numele organizației raportoare',
        full_query: 'Interogare completă',
        organization_code: 'Codul organizației',
        organization_name: 'Numele organizației',
        country: 'Țară',
        number_of_cases: 'Număr total de cazuri',
        wait_for_superiors_to_reply_cases: 'Numărul de cazuri care așteaptă răspunsul superiorilor',
        percentage_wait_for_superiors_to_reply_cases:
            'Procentul cazurilor care așteaptă răspunsul superiorilor',
        superior_replied_casess: 'Numărul de cazuri la care superiorii au răspuns',
        percentage_superior_replied_casess: 'Procentul cazurilor la care superiorii au răspuns',
        closed_cases: 'Numărul de cazuri închise',
        percentage_closed_cases: 'Procentul cazurilor închise',
    },
    // 挪威博克马尔
    nbNO: {
        fill_in_at_least_one_query_condition: 'Fyll ut minst ett søkekriterium',
        query_time: 'Spørringstidspunkt',
        reporting_organization_name: 'Rapporterende organisasjonsnavn',
        full_query: 'Full spørring',
        organization_code: 'Organisasjonskode',
        organization_name: 'Organisasjonsnavn',
        country: 'Land',
        number_of_cases: 'Totalt antall saker',
        wait_for_superiors_to_reply_cases: 'Antall saker som venter på svar fra overordnet',
        percentage_wait_for_superiors_to_reply_cases:
            'Prosentandel saker som venter på svar fra overordnet',
        superior_replied_casess: 'Antall saker besvart av overordnet',
        percentage_superior_replied_casess: 'Prosentandel saker besvart av overordnet',
        closed_cases: 'Antall lukkede saker',
        percentage_closed_cases: 'Prosentandel lukkede saker',
    },
    // 葡萄牙语巴西
    ptBX: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        query_time: 'Horário da consulta',
        reporting_organization_name: 'Nome da organização reportante',
        full_query: 'Consulta completa',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        wait_for_superiors_to_reply_cases: 'Quantidade de casos aguardando resposta do superior',
        percentage_wait_for_superiors_to_reply_cases:
            'Percentual de casos aguardando resposta do superior',
        superior_replied_casess: 'Quantidade de casos respondidos pelo superior',
        percentage_superior_replied_casess: 'Percentual de casos respondidos pelo superior',
        closed_cases: 'Quantidade de casos encerrados',
        percentage_closed_cases: 'Percentual de casos encerrados',
    },
    // 瑞典语
    svSE: {
        fill_in_at_least_one_query_condition: 'Ange minst ett sökvillkor',
        query_time: 'Förfråganstidpunkt',
        reporting_organization_name: 'Rapporterande organisationsnamn',
        full_query: 'Fullständig förfrågan',
        organization_code: 'Organisationskod',
        organization_name: 'Organisationsnamn',
        country: 'Land',
        number_of_cases: 'Totalt antal fall',
        wait_for_superiors_to_reply_cases: 'Antal ärenden som väntar på svar från chef',
        percentage_wait_for_superiors_to_reply_cases:
            'Andel ärenden som väntar på svar från chef (%)',
        superior_replied_casess: 'Antal ärenden besvarade av chef',
        percentage_superior_replied_casess: 'Andel ärenden besvarade av chef (%)',
        closed_cases: 'Antal avslutade ärenden',
        percentage_closed_cases: 'Andel avslutade ärenden (%)',
    },
    // 斯洛伐克
    skSK: {
        fill_in_at_least_one_query_condition: 'Zadajte aspoň jednu podmienku vyhľadávania',
        query_time: 'Čas dopytu',
        reporting_organization_name: 'Názov nahlásenej organizácie',
        full_query: 'Kompletný dopyt',
        organization_code: 'Kód organizácie',
        organization_name: 'Názov organizácie',
        country: 'Krajina',
        number_of_cases: 'Celkový počet prípadov',
        wait_for_superiors_to_reply_cases: 'Počet prípadov čakajúcich na odpoveď vyššieho stupňa',
        percentage_wait_for_superiors_to_reply_cases:
            'Percento prípadov čakajúcich na odpoveď vyššieho stupňa',
        superior_replied_casess: 'Počet prípadov, na ktoré vyšší stupeň odpovedal',
        percentage_superior_replied_casess: 'Percento prípadov, na ktoré vyšší stupeň odpovedal',
        closed_cases: 'Počet uzavretých prípadov',
        percentage_closed_cases: 'Percento uzavretých prípadov',
    },
    // 斯洛文尼亚
    slSI: {
        fill_in_at_least_one_query_condition: 'Vnesite vsaj en pogoj za poizvedbo',
        query_time: 'Čas poizvedbe',
        reporting_organization_name: 'Ime poročajoče organizacije',
        full_query: 'Polna poizvedba',
        organization_code: 'Koda organizacije',
        organization_name: 'Ime organizacije',
        country: 'Država',
        number_of_cases: 'Skupno število primerov',
        wait_for_superiors_to_reply_cases: 'Število primerov, ki čakajo na odgovor nadrejenih',
        percentage_wait_for_superiors_to_reply_cases:
            'Odstotek primerov, ki čakajo na odgovor nadrejenih',
        superior_replied_casess: 'Število primerov, na katere so nadrejeni že odgovorili',
        percentage_superior_replied_casess:
            'Odstotek primerov, na katere so nadrejeni že odgovorili',
        closed_cases: 'Število zaključenih primerov',
        percentage_closed_cases: 'Odstotek zaključenih primerov',
    },
    // 泰语
    thTH: {
        fill_in_at_least_one_query_condition: 'กรุณากรอกเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการ',
        query_time: 'เวลาการสอบถาม',
        reporting_organization_name: 'ชื่อองค์กรที่รายงาน',
        full_query: 'สอบถามข้อมูลทั้งหมด',
        organization_code: 'รหัสองค์กร',
        organization_name: 'ชื่อองค์กร',
        country: 'ประเทศ',
        number_of_cases: 'จำนวนกรณีทั้งหมด',
        wait_for_superiors_to_reply_cases: 'จำนวนกรณีที่รอผู้บังคับบัญชาตอบกลับ',
        percentage_wait_for_superiors_to_reply_cases:
            'เปอร์เซ็นต์ของกรณีที่รอผู้บังคับบัญชาตอบกลับ',
        superior_replied_casess: 'จำนวนกรณีที่ผู้บังคับบัญชาตอบกลับแล้ว',
        percentage_superior_replied_casess: 'เปอร์เซ็นต์ของกรณีที่ผู้บังคับบัญชาตอบกลับแล้ว',
        closed_cases: 'จำนวนกรณีที่ปิดแล้ว',
        percentage_closed_cases: 'เปอร์เซ็นต์ของกรณีที่ปิดแล้ว',
    },
    // 乌克兰语
    ukUA: {
        fill_in_at_least_one_query_condition: 'Будь ласка, введіть принаймні одну умову пошуку',
        query_time: 'Час запиту',
        reporting_organization_name: 'Назва організації, що повідомляє',
        full_query: 'Повний запит',
        organization_code: 'Код організації',
        organization_name: 'Назва організації',
        country: 'Країна',
        number_of_cases: 'Загальна кількість випадків',
        wait_for_superiors_to_reply_cases:
            'Кількість випадків, що очікують відповіді від керівництва',
        percentage_wait_for_superiors_to_reply_cases:
            'Відсоток випадків, що очікують відповіді від керівництва',
        superior_replied_casess: 'Кількість випадків, на які відповіло керівництво',
        percentage_superior_replied_casess: 'Відсоток випадків, на які відповіло керівництво',
        closed_cases: 'Кількість закритих випадків',
        percentage_closed_cases: 'Відсоток закритих випадків',
    },
    // 希腊语
    elGR: {
        fill_in_at_least_one_query_condition: 'Συμπληρώστε τουλάχιστον ένα κριτήριο αναζήτησης',
        query_time: 'Χρόνος ερωτήματος',
        reporting_organization_name: 'Όνομα του οργανισμού που υπέβαλε την αναφορά',
        full_query: 'Πλήρης ερώτημα',
        organization_code: 'Κωδικός οργανισμού',
        organization_name: 'Όνομα οργανισμού',
        country: 'Χώρα',
        number_of_cases: 'Συνολικός αριθμός περιστατικών',
        wait_for_superiors_to_reply_cases:
            'Αριθμός περιστατικών που αναμένουν απάντηση από ανώτερο',
        percentage_wait_for_superiors_to_reply_cases:
            'Ποσοστό περιστατικών που αναμένουν απάντηση από ανώτερο',
        superior_replied_casess: 'Αριθμός περιστατικών που απαντήθηκαν από ανώτερο',
        percentage_superior_replied_casess: 'Ποσοστό περιστατικών που απαντήθηκαν από ανώτερο',
        closed_cases: 'Αριθμός κλεισμένων περιστατικών',
        percentage_closed_cases: 'Ποσοστό κλεισμένων περιστατικών',
    },
    // 爱沙尼亚
    etEE: {
        fill_in_at_least_one_query_condition: 'Sisestage vähemalt üks otsingu tingimus',
        query_time: 'Päringu aeg',
        reporting_organization_name: 'Teavitava organisatsiooni nimi',
        full_query: 'Täielik päring',
        organization_code: 'Organisatsiooni kood',
        organization_name: 'Organisatsiooni nimi',
        country: 'Riik',
        number_of_cases: 'Juhtumite koguarv',
        wait_for_superiors_to_reply_cases: 'Ülemuse vastust ootavate juhtumite arv',
        percentage_wait_for_superiors_to_reply_cases: 'Ülemuse vastust ootavate juhtumite protsent',
        superior_replied_casess: 'Ülemuse poolt vastatud juhtumite arv',
        percentage_superior_replied_casess: 'Ülemuse poolt vastatud juhtumite protsent',
        closed_cases: 'Suletud juhtumite arv',
        percentage_closed_cases: 'Suletud juhtumite protsent',
    },
    // 哈萨克
    kkKZ: {
        fill_in_at_least_one_query_condition: 'Кем дегенде бір сұрау шартын енгізіңіз',
        query_time: 'Сұрау уақыты',
        reporting_organization_name: 'Есеп беретін ұйымның атауы',
        full_query: 'Толық сұрау',
        organization_code: 'Ұйым коды',
        organization_name: 'Ұйым атауы',
        country: 'Ел',
        number_of_cases: 'Жағдайлардың жалпы саны',
        wait_for_superiors_to_reply_cases: 'Жоғары басшылықтың жауабын күтетін жағдайлар саны',
        percentage_wait_for_superiors_to_reply_cases:
            'Жоғары басшылықтың жауабын күтетін жағдайлар пайызы',
        superior_replied_casess: 'Жоғары басшылық жауап берген жағдайлар саны',
        percentage_superior_replied_casess: 'Жоғары басшылық жауап берген жағдайлар пайызы',
        closed_cases: 'Жабылған жағдайлар саны',
        percentage_closed_cases: 'Жабылған жағдайлар пайызы',
    },
    // 希伯来语
    heIL: {
        fill_in_at_least_one_query_condition: 'יש למלא לפחות תנאי חיפוש אחד',
        query_time: 'זמן השאילתה',
        reporting_organization_name: 'שם הארגון המדווח',
        full_query: 'שאילתה מלאה',
        organization_code: 'קוד ארגון',
        organization_name: 'שם הארגון',
        country: 'מדינה',
        number_of_cases: 'סך כל המקרים',
        wait_for_superiors_to_reply_cases: 'כמות מקרים הממתינים לתגובה מהגבוהים',
        percentage_wait_for_superiors_to_reply_cases: 'אחוז מקרים הממתינים לתגובה מהגבוהים',
        superior_replied_casess: 'כמות מקרים שהגבוהים כבר השיבו עליהם',
        percentage_superior_replied_casess: 'אחוז מקרים שהגבוהים כבר השיבו עליהם',
        closed_cases: 'כמות מקרים שנסגרו',
        percentage_closed_cases: 'אחוז מקרים שנסגרו',
    },
};
